<template>
  <div class="main">
    <GoBack :name="`公告详情`" :type="2" :path="`/mobile/allNews`"></GoBack>

    <div class="content-box">
      <!-- 公告标题区域 -->
      <div class="title-section">
        <h2 class="title">{{ options.title }}</h2>
        <div class="meta">
          <span class="publish-time">{{ options.dateline | dateFormat }}</span>
        </div>
      </div>

      <!-- 公告内容区域 -->
      <div class="content-section">
        <div class="body" v-html="options.content"></div>
      </div>

      <!-- 加载状态 -->
      <van-loading v-if="loading" size="24px" vertical>加载中...</van-loading>
      
      <!-- 空状态 -->
      <van-empty v-if="!loading && !options.title" description="暂无数据" />
    </div>
  </div>
</template>

<script>
import GoBack from "@/components/goBack.vue";
import { getNewsItem } from "@/api/mobile";

export default {
  filters: {
    dateFormat(data) {
      if (!data) return "-";
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      options: {},
      loading: false,
    };
  },
  methods: {
    // 获取公告详情
    getNewsDetail() {
      const id = this.$route.query.id;
      
      // 参数校验
      if (!id) {
        console.error("缺少公告ID参数");
        return;
      }

      this.loading = true;
      getNewsItem({ id })
        .then((res) => {
          this.loading = false;
          if (res.code === 200) {
            this.options = res.data || {};
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error("获取公告详情失败:", error);
        });
    },
  },
  components: {
    GoBack,
  },
  created() {
    this.getNewsDetail();
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 100vh;
  background-color: #f8f8fa;
  width: 100%;

  .content-box {
    padding-bottom: 20px;

    // 标题区域
    .title-section {
      background: #ffffff;
      padding: 20px 15px;
      border-bottom: 1px solid #f0f0f0;

      .title {
        margin: 0 0 10px 0;
        font-size: 20px;
        color: #333;
        font-weight: 600;
        line-height: 1.5;
      }

      .meta {
        .publish-time {
          font-size: 13px;
          color: #999;
        }
      }
    }

    // 内容区域
    .content-section {
      background: #ffffff;
      padding: 20px 15px;
      min-height: calc(100vh - 200px);

      .body {
        font-size: 15px;
        color: #666;
        line-height: 1.8;

        ::v-deep {
          p {
            margin: 12px 0;
          }

          img {
            max-width: 100%;
            height: auto;
            border-radius: 4px;
            margin: 12px 0;
          }

          a {
            color: #409eff;
            text-decoration: none;

            &:active {
              opacity: 0.7;
            }
          }

          h1,
          h2,
          h3,
          h4,
          h5,
          h6 {
            margin: 18px 0 8px 0;
            color: #333;
            font-weight: 600;
          }

          ul,
          ol {
            padding-left: 20px;
            margin: 12px 0;
          }

          li {
            margin: 6px 0;
          }

          blockquote {
            padding: 10px 12px;
            margin: 12px 0;
            background: #f5f7fa;
            border-left: 3px solid #409eff;
            color: #666;
          }

          table {
            width: 100%;
            border-collapse: collapse;
            margin: 12px 0;
            font-size: 14px;

            th,
            td {
              padding: 8px;
              border: 1px solid #e8e8e8;
              text-align: left;
            }

            th {
              background: #fafbfc;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
</style>
